import { ItemsEcCat } from "./../../../modals/items-ec-cat";
import { TestBed } from "@angular/core/testing";
import { ItemsService } from "./../../../services/items.service";
import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject, Subscriber, Subject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Product } from "src/app/modals/product.model";
import { MatSnackBar } from "@angular/material";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthService } from "./auth.service";
import { BannerList } from "src/app/modals/banner-list";
import { BanerItemsIncio } from "src/app/modals/baner-items-incio";
import { DatePipe } from "@angular/common";
import { constApi } from "src/environments/constApi";
import { NgxSpinnerService } from "ngx-spinner";
import { EcommerceNpService } from "./ecommerce-np.service";

const baseUrl = environment.apiUrl;

// Get product from Localstorage
let products = JSON.parse(localStorage.getItem("compareItem")) || [];

@Injectable({
  providedIn: "root",
})
export class ProductService {
  public currency: string = "USD";
  public catalogMode: boolean = false;

  private _url: string = "assets/data/";
  public url = "assets/data/banners.json";

  public compareProducts: BehaviorSubject<Product[]> = new BehaviorSubject([]);
  public observer: Subscriber<{}>;
  private tkn: any;
  private headers: any;
  constructor(
    private httpClient: HttpClient,
    public snackBar: MatSnackBar,
    public itemsService: ItemsService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    
  ) {
    this.compareProducts.subscribe((products) => (products = products));
    if (this.authService.isLogin()) {
      this.tkn = JSON.parse(sessionStorage.getItem("tk"));
      this.headers = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.tkn.Token,
      });
    }
  }

  public banners(): Observable<BanerItemsIncio[]> {
    let result: BanerItemsIncio = new BanerItemsIncio();
    let urlBanners: any = environment.apiUrl + "/inicioec";
    var subject = new Subject<any>();
    this.httpClient.get<any>(urlBanners).subscribe((res: any) => {
      result.banner_Prc = res.banner_Prc;
      result.banner_Sld = res.banner_Sld;
      result.banner_Pub = res.banner_Pub;
      result.itemsEC_Destacados = res.itemsEC_Destacados;
      result.itemsEC_Browse = res.itemsEC_Browse;
      let itemsEcCat: ItemsEcCat = new ItemsEcCat();
      itemsEcCat.itemsEC_Cat1 = res.itemsEC_Cat1;
      itemsEcCat.itemsEC_Cat2 = res.itemsEC_Cat2;
      itemsEcCat.itemsEC_Cat3 = res.itemsEC_Cat3;
      result.itemsEcCat = itemsEcCat;
      subject.next(result);
    });
    // return this.httpClient.get<any[]>(this.url);
    return subject.asObservable();
  }

  // Get Banners
  public getBanners() {
    return this.banners();
  }

  private products(): Observable<Product[]> {
    let result: any[] = [];
    let paramString = {
      Codigo: "1",
    };

    let urlProductos: any =
      environment.apiUrl +
      constApi.ITEMSEC_LIST +
      "?Codigo=" +
      paramString.Codigo;
    let an: any;
    var subject = new Subject<any>();
    this.httpClient.get<any>(urlProductos).subscribe((res: any) => {
      res.forEach((next) => {
        let product: Product;
        product = res;
        product.ImagenP =
          next.ImagenP == null
            ? "https://novaplaza.pe/assets/img/nodisponible.png"
            : next.ImagenP;

        subject.next(product);
      });
    });
    return subject.asObservable();
  }

  private productsParam(param): Observable<Product[]> {
    let result: Product[] = [];
    let paramUrl = "";
    param.forEach((el) => {
      if (typeof el.valor != undefined) {
        if (el.valor != null) {
          if (el.valor != 0) paramUrl += el.clave + "=" + el.valor + "&";
        }
      }
    });

    //////console.log(paramUrl);

    let urlProductos: any = environment.apiUrl + "/ItemsEC/List?" + paramUrl;
    var subject = new Subject<any>();
    this.spinner.show();
    this.httpClient.get<any>(urlProductos).subscribe((res: any) => {
      let url = document.location.href.split("#");
      res.forEach((x) => {
        // if(x.PV6 > 0){
        //   if(x.SaldoG == 0){
        //     x.SaldoG = 1
        //     x.Saldo = 1
        //   }
        // }
        x.ImagenP =
          x.ImagenP == null || x.ImagenP.length == 0
            ? "https://novaplaza.pe/assets/img/nodisponible.png"
            : x.ImagenP;
        result.push(x);
        subject.next(result);
        this.spinner.hide();
      });
    });
    this.spinner.hide();
    return subject.asObservable();
  }

  // public

  // Get Banners
  public getProducts(): Observable<Product[]> {
    return this.products();
  }

  public getProductbyparam(param): Observable<Product[]> {
    return this.productsParam(param);
  }

  // Get Products By Id
  public getProduct(id: number): Observable<Product> {
    return this.products().pipe(
      map((items) => {
        return items.find((item: Product) => {
          return item.idItem === id;
        });
      })
    );
    // return this.products.find(product=> product.id === id);

    // return this.httpClient.get<Product>(this._url + 'product-' + id + '.json');
  }

  /*
---------------------------------------------
----------  Compare Product  ----------------
---------------------------------------------
*/

  // Get Compare Products
  public getComapreProducts(): Observable<Product[]> {
    const itemsStream = new Observable((observer) => {
      observer.next(products);
      observer.complete();
    });
    return <Observable<Product[]>>itemsStream;
  }

  // If item is aleready added In compare
  public hasProduct(product: Product): boolean {
    const item = products.find((item) => item.id === product.idItem);
    return item !== undefined;
  }

  // Add to compare
  public addToCompare(product: Product): Product | boolean {
    let message, status;
    var item: Product | boolean = false;
    if (this.hasProduct(product)) {
      item = products.filter((item) => item.id === product.idItem)[0];
      const index = products.indexOf(item);
      this.snackBar.open(
        "The product  " +
          product.NombreItm +
          " ya agregado a la lista de comparacion.",
        "×",
        { panelClass: "error", verticalPosition: "top", duration: 3000 }
      );
    } else {
      if (products.length < 4) products.push(product);
      message =
        "The product " +
        product.NombreItm +
        " has been added to comparison list.";
      status = "success";
      this.snackBar.open(message, "×", {
        panelClass: [status],
        verticalPosition: "top",
        duration: 3000,
      });
    }
    localStorage.setItem("compareItem", JSON.stringify(products));
    return item;
  }

  // Removed Product
  public removeFromCompare(product: Product) {
    if (product === undefined) {
      return;
    }
    const index = products.indexOf(product);
    products.splice(index, 1);
    localStorage.setItem("compareItem", JSON.stringify(products));
  }

  // Get Products By category
  public getProductByCategory(category: string): Observable<Product[]> {
    return this.products().pipe(
      map((items) =>
        items.filter((item: Product) => {
          if (category == "all") return item;
          else return item.Codigo === category;
        })
      )
    );
  }

  public calificaValProm(idItem, valoracion) {
    let urlCalifica: any =
      environment.apiUrl + "/Items/Valora/" + idItem + "/" + valoracion;
    let an: any;
    var subject = new Subject<any>();
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.httpClient.put(urlCalifica, { headers: headers });
  }

  public getPedidos(param) {
    let paramString = "";
    for (let i = 0; i < param.length; i++) {
      if (param[i].valueparam != "" && param[i].valueparam != "null") {
        paramString += param[i].keyparam + "=" + param[i].valueparam + "&";
      }
    }
    let urlProductos = environment.apiUrl + "/Pedidos?" + paramString;
    return this.httpClient.get(urlProductos, { headers: this.headers });
  }

  public getProductsById(codigo) {
    let date = Date.now();
    var datePipe = new DatePipe("en-US");
    let anioPeriodo = datePipe.transform(date, "yyyy");
    let urlProductos: any =
      environment.apiUrl +
      "/ItemsEC/List?idItem=" +
      codigo +
      "&periodo=" +
      anioPeriodo;
    return this.httpClient.get<Product[]>(urlProductos);
  }
  public getProductsECById(codigo) {
    let date = Date.now();
    var datePipe = new DatePipe("en-US");
    let anioPeriodo = datePipe.transform(date, "yyyy");
    let urlProductos: any =
      environment.apiUrl +
      "/ItemsEC/List?idItemEC=" +
      codigo
    return this.httpClient.get<Product[]>(urlProductos);
  }

  public getBannerBrowse() {
    let urlBanners: any = environment.apiUrl + "/inicioec";
    return this.httpClient.get<BannerList[]>(urlBanners);
  }

  public getProductsCategoria(codigo) {
    let date = Date.now();
    var datePipe = new DatePipe("en-US");
    let anioPeriodo = datePipe.transform(date, "yyyy");
    let urlProductos: any =
      environment.apiUrl +
      "/ItemsEC/List?Codigo=" +
      codigo +
      "&periodo=" +
      anioPeriodo;
    return this.httpClient.get<Product[]>(urlProductos);
  }

  public getDestacados(codigo) {
    let urlProductos: any = environment.apiUrl + "/ItemsEC/List?TItemEC=ITD&Codigo=" + codigo;
    return this.httpClient.get<any>(urlProductos);
  }

  public getMarcas(param) {
    let paramUrl = "";
    param.forEach((el) => {
      if (typeof el.valor != undefined) {
        if (el.valor != null) {
          if (el.valor != 0) paramUrl += el.clave + "=" + el.valor + "&";
        }
      }
    });
    let urlMarcas: any = environment.apiUrl + "/ItemsEc/Marcas/List?" + paramUrl;
    return this.httpClient.get(urlMarcas);
  }

  public getPrecios(param) {
    let paramUrl = "";
    param.forEach((el) => {
      if (typeof el.valor != undefined) {
        if (el.valor != null) {
          if (el.valor != 0) paramUrl += el.clave + "=" + el.valor + "&";
        }
      }
    });
    let urlMarcas: any = environment.apiUrl + "/Items/PV_EC_List?" + paramUrl;
    return this.httpClient.get(urlMarcas);
  }
  getParam(urlApi, param: any): Observable<any> {
    let ultimocaracter = urlApi.substr(urlApi.length - 1);
    let paramUrl: any = "";
    if (ultimocaracter == "/") {
      param.forEach((el) => {
        paramUrl += el.valor + "/";
      });
    } else {
      paramUrl = "?";
      param.forEach((el) => {
        if (typeof el.valor != undefined) {
          if (el.valor != null) {
            if (el.valor.length != 0)
              paramUrl += el.clave + "=" + el.valor + "&";
          }
        }
      });
    }

    baseUrl + paramUrl;
    return this.httpClient.get(baseUrl + urlApi + paramUrl, {
      observe: "response",
    });
  }
}
